<template>
    <div class="columns">
      <contribution-card :linkedProject="project" :isHalf="true" :recommendationSource="sourceProjectID" recommendationType="leo"></contribution-card>
    </div>
</template>

<script>
import ContributionCard from '@/components/Cards/ProjectCards/Types/Contributions'

export default {
  components: { ContributionCard },
  props: ['attachment'],
  computed: {
    project: function () {
      return this.attachment && this.attachment.metadata && this.attachment.metadata.project ? this.attachment.metadata.project : {}
    },
    sourceProjectID: function () {
      return this.attachment && this.attachment.metadata && this.attachment.metadata.sourceProjectID > 0 ? this.attachment.metadata.sourceProjectID : null
    }
  }
}
</script>

<style lang="scss" scoped>
  .columns {
    justify-content: center;
    padding: 1rem;
  }
</style>
